module.exports = __webpack_public_path__ + "static/media/design_pattern.4d140c65.png";